// extracted by mini-css-extract-plugin
export default {"contenedor":"Settings_contenedor__a7YTF","rectangulo":"Settings_rectangulo__IEsOE","in":"Settings_in__1388M","mensaje":"Settings_mensaje__YXWRO"};